import { Empty, Input, Select } from "antd";
import IconButton from "components/common/IconButton";
import useMessageTemplates from "hooks/message-templates/useMessageTemplates";
import useDebounce from "hooks/route-rules/useDebounce";
import React, { useEffect, useState } from "react";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import TemplatesTable from "./TemplatesTable";
import { Spinner, Row, Col } from "react-bootstrap"; // Added Row/Col for alignment
import { useNavigate } from "react-router-dom";

export default function MessageTemplates() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCode, setSelectedCode] = useState("ALL");
  const [codeOptions, setCodeOptions] = useState([
    { label: "All Codes", value: "ALL" },
  ]);
  
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const isSearchRequest = debouncedSearchTerm.trim().length >= 3;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const {
    loading,
    totalPages,
    totalElements,
    messageTemplates,
    deleteTemplate,
    searchTemplates,
  } = useMessageTemplates(page, pageSize);

  useEffect(() => {
    const uniqueCodes = Array.from(
      new Set(
        (messageTemplates || [])
          .map((item) => String(item?.code || "").trim())
          .filter(Boolean),
      ),
    );

    setCodeOptions((prev) => {
      const map = new Map(
        prev
          .filter((opt) => opt.value !== "ALL")
          .map((opt) => [opt.value, opt]),
      );
      uniqueCodes.forEach((code) => {
        if (!map.has(code)) {
          map.set(code, { label: code, value: code });
        }
      });
      return [{ label: "All Codes", value: "ALL" }, ...map.values()];
    });
  }, [messageTemplates]);


  useEffect(() => {
    const trimmed = debouncedSearchTerm.trim();
    searchTemplates(trimmed, selectedCode, page, pageSize);
  }, [debouncedSearchTerm, page, pageSize, searchTemplates, selectedCode]);

  return (
    <>
      <WidgetSectionTitle
        icon="envelope-open-text"
        title="Message Templates"
        subtitle="Manage email and sms templates"
        transform="shrink-2"
        className="mb-3 mt-3 fw-normal" // Normal weight
      />

      <div className="d-flex justify-content-end mb-4">
        <IconButton
          variant="success"
          size="sm"
          icon="plus"
          onClick={() => navigate(`/account/message-templates/create`)}
          className="text-xs text-white px-3 fw-normal" // Normal weight
          style={{ height: 32 }}
        >
          <span className="ms-1">Add New Template</span>
        </IconButton>
      </div>

      {/* Aligned Search and Filter to match ClientIDs/Agreements */}
 <Row className="mb-2 g-3 align-items-center">
        <Col md={8} lg={9}>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <Input
              prefix={<span className="fas fa-search" style={{ fontSize: 13, color: "#94a3b8" }} />}
              placeholder="Search by name, code or affiliation..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(0);
              }}
              allowClear
              size="large"
              style={{ borderRadius: 12, height: 30, flex: "1 1 300px", maxWidth: 300 }}
              suffix={
                loading && isSearchRequest ? (
                  <Spinner animation="border" size="sm" variant="success" style={{ width: 12, height: 12 }} />

                ) : null
              }
            />
            <Select
              size="large"
              value={selectedCode}
              onChange={(val) => {
                setSelectedCode(val);
                setPage(0);
              }}
              options={codeOptions}
              style={{ minWidth: 180, height: 28 }}
            />
          </div>
        </Col>
        <Col md={4} lg={3} className="text-end">
          <div style={{ fontSize: 13, color: "#64748b" }}>
            Results: <span className="fw-normal text-dark">{messageTemplates.length}</span> of <span className="fw-normal text-dark">{totalElements || 0}</span>
          </div>
        </Col>
      </Row>

      <div className="position-relative">
        {loading && messageTemplates.length === 0 ? (
          <div className="py-5 bg-white text-center">
            <Spinner animation="border" variant="success" size="sm" />
            <div className="mt-2 text-500 fs-10 fw-normal">Loading templates...</div>
          </div>
        ) : messageTemplates && messageTemplates.length === 0 ? (
          <div className="py-5 bg-white rounded-3 border border-200 text-center fw-normal">
            <Empty
              description={
                searchTerm.trim() ? `No templates found for "${searchTerm}"` : "No templates found"
              }
            />
          </div>
        ) : (
          <TemplatesTable
            templates={messageTemplates}
            deleteTemplate={deleteTemplate}
            page={page}
            pageSize={pageSize}
            setPage={setPage}
            setPageSize={setPageSize}
            totalPages={totalPages}
            totalElements={totalElements}
          />
        )}
      </div>
    </>
  );
}














